// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (-webkit-min-device-pixel-ratio:0){input[data-v-7b00ee43],select[data-v-7b00ee43],textarea[data-v-7b00ee43]{font-size:16px}}@media(max-width:767px){.ps-product__shopping[data-v-7b00ee43]{border:0!important;margin-bottom:0!important;padding-bottom:0}.cart-btns-mob[data-v-7b00ee43]{display:none}}.more-button[data-v-7b00ee43]{background-color:#fb9013;border-radius:4px;color:#fff;height:25px;padding:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
